import { Link, useMatch, useResolvedPath } from "react-router-dom";
import { BsChevronRight } from "react-icons/bs";

export default function SideMenu({ menu }: any) {
  let resolved = useResolvedPath(menu?.to);
  let match = useMatch({ path: resolved.pathname, end: false });
  return (
    <Link
      to={menu?.to}
      className={`flex justify-between items-center w-full py-6 border-l-4 ${
        match ? "border-toyota bg-gray-100" : "hover:bg-gray-50 border-white"
      } px-6`}
    >
      <div className="uppercase">{menu?.name}</div>
      <div className="flex justify-center items-center text-xs">
        {menu?.hasMore ? "View All" : ""}
        <BsChevronRight />
      </div>
    </Link>
  );
}
